import { render, staticRenderFns } from "./PaypalPay.vue?vue&type=template&id=31ac3816&lang=true&"
import script from "./PaypalPay.vue?vue&type=script&lang=js&"
export * from "./PaypalPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports